import PageTitleBlock from '@organisms/PageTitleBlock';
import {
  BlockWithBorder, CopyFileWrapper,
  LicenseContentWrapper,
  LicenseInfoWrapper,
  LicenseInputWrapper,
  LicensePageWrapper,
  LicenseUsersRow,
} from '@pages/LicensePage.styles';
import Text from '@atoms/Text';
import {theme} from '@styles/theme';
import StatusLabel from '@atoms/StatusLabel';
import Input from '@atoms/Input';
import {useState} from 'react';
import {CopyFile} from '@carbon/icons-react';

export const LicensePage = () => {
  const [licenseKey, setLicenseKey] = useState('Ghj3ha)fdhdkskfdjfk@fskks');

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(licenseKey);
    } catch (err) {
      console.error('Ошибка копирования:', err);
    }
  };

  return (
    <LicensePageWrapper>
      <PageTitleBlock title="Лицензия" />
      <LicenseContentWrapper>
        <LicenseInfoWrapper>
          <BlockWithBorder>
            <Text text="Статус" color={theme.colors.basic02} type="tinyR" />
            <StatusLabel text="Активен" />
          </BlockWithBorder>
          <BlockWithBorder>
            <Text text="Кол-во пользователей" color={theme.colors.basic02} type="tinyR" />
            <LicenseUsersRow>
              <Text text="46" type="subtitleR" color={theme.colors.signalGreen00} />
              <Text text="/" type="subtitleR" color={theme.colors.basic03} />
              <Text text="100" type="subtitleR" />
            </LicenseUsersRow>
          </BlockWithBorder>
          <BlockWithBorder>
            <Text text="Активна до" color={theme.colors.basic02} type="tinyR" />
            <Text text="24.08.2026" type="subtitleR" />
          </BlockWithBorder>
        </LicenseInfoWrapper>
        <LicenseInputWrapper>
          <Input
            id="license-key"
            label="Ключ лицензии"
            value={licenseKey}
            onChange={e => {
              setLicenseKey(e.currentTarget.value);
            }}
            withoutErrorText
            width="334px"
          />
          <CopyFileWrapper onClick={copyToClipboard}>
            <CopyFile size={16} fill={theme.colors.accent00} />
          </CopyFileWrapper>
        </LicenseInputWrapper>
      </LicenseContentWrapper>
    </LicensePageWrapper>
  );
};

export default LicensePage;
